type Props = {
  onClick?: () => void;
  className?: string;
};

export function Wordmark({ onClick, className = "" }: Props) {
  const interactive = !!onClick;
  return (
    <span
      className={`wm ${className}`}
      role={interactive ? "button" : undefined}
      tabIndex={interactive ? 0 : undefined}
      onClick={onClick}
      onKeyDown={(e) => {
        if (!interactive) return;
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          onClick?.();
        }
      }}
    >
      <span className="wm-text">
        Udi<span className="wm-accent">School</span>
      </span>
    </span>
  );
}
